module.exports = __webpack_public_path__ + "pc/img/about-global-pic01.966d8f40.png";